
import Test from '../views/admin/Test'
import Main from '../views/Main.vue'
import BookMarkList from '../views/bookmark/BookMarkList'
import Share from '../views/bookmark/share'

const favor = [
  {
    path: '/',
    name: 'Main',
    component: Main,
    children: [
      {
        path: '/',
        name: 'BookMarkList',
        component: BookMarkList
      }
    ]
  },
  {
    path: '/share/:id',
    name: 'Share',
    component: Share,
  },
  {
    path: '/Test',
    name: 'Test',
    component: Test,
    children: [

    ]
  },
]


export default favor
